import { useLoading } from './ProgressContext';

const SubscriptionService = () => {
  // Create an Axios instance
  const { axiosInstance } = useLoading(); // Use the Axios instance from context

  const api = axiosInstance;

  // Define the service methods
  const getSubscriptions = async () => {
    try {
      const response = await api.get('api/Subscription/GetSubscriptions');
      return response.data;
    } catch (error) {
      console.error('Error getting subscriptions:', error);
      throw error;
    }
  };

   const getAllSubscriptions = async ({ page = 1, pageSize = 20, isActive, user, package_id } = {}) => {
    try {
      const params = new URLSearchParams();

      params.set('page', String(page < 1 ? 1 : page));
      params.set('pageSize', String(pageSize));

      if (isActive !== undefined && isActive !== null && isActive !== '') {
        params.set('isActive', String(isActive));
      }

      if (user && user.trim()) {
        params.set('user', user.trim());
      }

      if (package_id && package_id.trim()) {
        params.set('package_id', package_id.trim());
      }

      const response = await api.get(`api/SubscriptionAdmin/GetAllSubscriptions?${params.toString()}`);
      return response.data;
    } catch (error) {
      if (error?.response?.status === 404) {
        return {
          data: [],
          page: 1,
          page_size: pageSize,
          total: 0,
          total_pages: 0,
        };
      }

      console.error('Error getting subscriptions:', error);
      throw error;
    }
  };

  // post method for userEmail, packageId and paidAmount
    const addSubscription = async (data) => {
        try {
        const response = await api.post(`api/SubscriptionAdmin/AddSubscription`, data);
        return response.data;
        } catch (error) {
        console.error('Error adding subscription:', error);
        throw error;
        }
    };

  
  const getDocumentStats = async ({ startDate, endDate } = {}) => {
    try {
      const params = new URLSearchParams();
      params.set('startDate', startDate);
      params.set('endDate', endDate);
      const response = await api.get(`api/HCAdmin/GetDocumentStats?${params.toString()}`);
      return response.data;
    } catch (error) {
      console.error('Error getting document stats:', error);
      throw error;
    }
  };

  // Return all methods as an object
  return {
    getSubscriptions,
    getAllSubscriptions,
    addSubscription,
    getDocumentStats,
  };
};

export default SubscriptionService;